import { useState } from "react";
import Stack from "../Utils/Stack.styled";
import { Checkbox, FormControlLabel } from "@mui/material";
import theme from "../../styles/Theme.styled";

const CheckboxGroup = ({ lists, onUpdateCheckbox }) => {
  const [checkboxState, setCheckboxState] = useState(lists);
  const handleChange = (event) => {
    checkboxState.set(event.target.name, event.target.checked);
    setCheckboxState(new Map(checkboxState));
    onUpdateCheckbox(checkboxState);
  };

  const RenderCheckbox = ({ name }) => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            sx={{
              color: theme.colors.black,
              "&.Mui-checked": {
                color: theme.colors.primary,
              },
            }}
            checked={checkboxState.get(name)}
            onChange={handleChange}
            name={name}
          />
        }
        label={name}
      />
    );
  };

  return (
    <Stack direction="column" gap="8">
      {Array.from(checkboxState.keys()).map((key, i) => (
        <RenderCheckbox key={i} name={key} />
      ))}
    </Stack>
  );
};

export default CheckboxGroup;
